import React, { useState, useEffect, useCallback, useRef } from 'react';
import logo from '../../assets/gbl-logo.png';
import { useAuth } from '../../context/AuthContext';
import { getDocumentRequests } from '../../services/notificationService';
import NotificationPanel from '../notifications/NotificationPanel';

export default function MobileHeader() {
  const { fbUser } = useAuth();
  const [showNotifications, setShowNotifications] = useState(false);
  const [requests, setRequests] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const panelRef = useRef(null);

  const fetchRequests = useCallback(async () => {
    if (!fbUser) return;
    try {
      const { data } = await getDocumentRequests(fbUser);
      setRequests(data.data?.requests || []);
      setUnreadCount(data.data?.unreadCount || 0);
    } catch (e) { /* ignore */ }
  }, [fbUser]);

  useEffect(() => {
    fetchRequests();
    const interval = setInterval(fetchRequests, 30000);
    return () => clearInterval(interval);
  }, [fetchRequests]);

  useEffect(() => {
    const handleClick = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setShowNotifications(false);
      }
    };
    if (showNotifications) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [showNotifications]);

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-[#DADCE0] md:hidden">
      <div className="flex items-center justify-between px-4 h-14">
        <div className="flex items-center gap-2.5">
          <img src={logo} alt="GBL Tree" className="h-8" />
          <span className="text-sm font-medium text-[#5F6368]">Student Portal</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="relative" ref={panelRef}>
            <button
              onClick={() => setShowNotifications(!showNotifications)}
              className="relative text-[#5F6368] hover:text-[#202124] p-2 rounded-full hover:bg-[#F1F3F4] transition"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
              {unreadCount > 0 && (
                <span className="absolute top-0.5 right-0.5 min-w-[16px] h-[16px] bg-[#D93025] text-white text-[9px] font-bold rounded-full flex items-center justify-center leading-none px-0.5">
                  {unreadCount > 9 ? '9+' : unreadCount}
                </span>
              )}
            </button>
            {showNotifications && (
              <NotificationPanel
                requests={requests}
                onRefresh={fetchRequests}
                onClose={() => setShowNotifications(false)}
              />
            )}
          </div>

          {fbUser?.photoURL ? (
            <img
              src={fbUser.photoURL}
              alt=""
              referrerPolicy="no-referrer"
              className="w-8 h-8 rounded-full object-cover"
            />
          ) : (
            <div className="w-8 h-8 rounded-full bg-[#1A73E8] flex items-center justify-center text-white font-medium text-xs">
              {fbUser?.displayName?.charAt(0)?.toUpperCase()}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
